import firebase from "../../config/firebase";

export const getResolutions =
  (lastDoc = null, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch({ type: "FETCH_RESOLUTIONS_PENDING" });
    try {
      const resolutionsCollectionRef = firebase
        .firestore()
        .collection("resolutions");
      const resolutionsLimit = 5;

      let q = resolutionsCollectionRef
        .orderBy("createdAt", "desc")
        .limit(resolutionsLimit);

      if (lastDoc) {
        q = q.startAfter(lastDoc);
      }
      const querySnapshot = await q.get();
      // const unsubscribe = q.onSnapshot((querySnapshot) => {
        const resolutions = [];
        let lastVisible = null;

        querySnapshot.forEach((doc) => {
          resolutions.push({ id: doc.id, ...doc.data() });
          lastVisible = doc;
        });

        const hasMoreResolutions = querySnapshot.size >= resolutionsLimit;

        dispatch({
          type: lastDoc
            ? "FETCH_RESOLUTIONS_LOAD_MORE_SUCCESS"
            : "FETCH_RESOLUTIONS_SUCCESS",
          payload: {
            resolutions,
            lastDoc: lastVisible,
            hasMoreResolutions,
          },
        });

        onSuccess();
      // });

      // return unsubscribe;
    } catch (error) {
      console.error("Error fetching resolutions:", error.message);
      dispatch({
        type: "FETCH_RESOLUTIONS_REJECTED",
        error: error.message,
      });
      onSuccess();
    }
  };

export const getSingleResolution = (ID) => async (dispatch) => {
  try {
    dispatch({ type: "SET_IS_LOADINGS", payload: true });
    firebase
      .firestore()
      .collection("resolutions")
      .doc(ID)
      .onSnapshot(async (data) => {
        dispatch({ type: "GET_SINGLE_RESOLUTION", payload: data.data() });
        dispatch({ type: "SET_IS_LOADINGS", payload: false });
      });
  } catch (error) {
    console.error(error);
    dispatch({ type: "SET_IS_LOADINGS", payload: false });
  }
};

export const resolutionChat = (ID) => async (dispatch) => {
  try {
    dispatch({ type: "SET_IS_LOADINGS", payload: true });
    const unsubscribe = firebase.firestore().collection("resolutions").doc(ID);
    unsubscribe
      .collection("messages")
      .orderBy("createdAt", "asc")
      .onSnapshot(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          temp_data.push({
            ...doc.data(),
          });
        }
        dispatch({ type: "GET_RESOLUTION_CHAT", payload: temp_data });
        dispatch({ type: "SET_IS_LOADINGS", payload: false });
      });

    return () => unsubscribe();
  } catch (error) {
    console.error(error);
    dispatch({ type: "SET_IS_LOADINGS", payload: false });
  }
};

export const getSingleUser = (ID) => async (dispatch) => {
  try {
    dispatch({ type: "SET_IS_LOADINGS", payload: true });
    const userRef = firebase.firestore().collection("users").doc(ID);
    const userDoc = await userRef.get();

    if (userDoc.exists) {
      const userData = userDoc.data();
      dispatch({ type: "GET_SINGLE_USER", payload: userData });
      dispatch({ type: "SET_IS_LOADINGS", payload: false });
    } else {
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: "SET_IS_LOADINGS", payload: false });
  }
};

export const addChat = (resolutionId, data, senderId) => async (dispatch) => {
  try {
    const resolutionsCollectionRef = firebase
      .firestore()
      .collection("resolutions");

    const resolutionDocRef = resolutionsCollectionRef.doc(resolutionId);

    const messagesCollectionRef = resolutionDocRef.collection("messages");

    const timestampedData = {
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      message: data,
      senderId: senderId,
    };

    const newMessageDocRef = await messagesCollectionRef.add(timestampedData);

    dispatch({ type: "ADD_CHAT_SUCCESS", payload: newMessageDocRef.id });
  } catch (error) {
    console.error(error);
    dispatch({ type: "ADD_CHAT_FAILURE", payload: error.message });
  }
};

export const updateStatus = (ID, status) => async (dispatch) => {
  const resolutionRef = await firebase.firestore().collection("resolutions");

  try {
    await resolutionRef.doc(ID).update({
      status: status,
    });
  } catch (error) {
    console.error("Error updating status:", error);
  }
};
